import { LabelWrapper } from '@/modules/global-components/ui/wrappers/LabelWrapper';
import { useTranslation } from '@/hooks/useTranslation';
import {
  Dropdown,
  type DropdownChangeEvent,
  type DropdownProps,
} from 'primereact/dropdown';
import { memo } from 'react';
import { EllipseLabel } from '../wrappers/EllipseLabel';
import { cn } from '@/helpers/utils/functionality-utils';
// 'onBlur' | 'onContextMenu' | 'onFocus' | 'onChange' | 'onMouseDown'|"accessKey"
export interface SelectProps extends DropdownProps {
  label: string;
  onChange?: (event: DropdownChangeEvent) => void;
  error?: unknown;
  options: unknown[];
  optionLabel?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
  containerStyles?: React.CSSProperties;
  style?: React.CSSProperties;
  imp?: boolean;
  labelClassname?: string;
  filter?: boolean;
  footer?: React.ReactNode;
  matchTitleOfInfoText?: boolean;
  onlyDropdown?: boolean;
}

export const Select = memo(
  ({
    label,
    placeholder,
    className,
    value,
    onChange,
    error,
    options,
    optionLabel = 'name',
    containerClassName,
    containerStyles,
    style,
    imp,
    labelClassname,
    filter = true,
    footer,
    showClear = false,
    matchTitleOfInfoText,
    onlyDropdown = false,
    ...props
  }: SelectProps) => {
    const { t } = useTranslation('carriers');
    if (onlyDropdown) {
      return (
        <Dropdown
          showOnFocus
          resetFilterOnHide={filter}
          filterInputAutoFocus={filter}
          autoOptionFocus={filter}
          showClear={showClear}
          filter={filter}
          showFilterClear={filter}
          value={value}
          onChange={onChange}
          options={options}
          optionLabel={
            optionLabel?.toLowerCase() === 'none' ? undefined : optionLabel
          }
          placeholder={placeholder || t('dropdownPlaceholder')}
          style={style}
          className={cn('w-full', className)}
          itemTemplate={(option) => {
            return (
              <EllipseLabel
                label={optionLabel === 'none' ? option : option[optionLabel]}
              />
            );
          }}
          pt={{
            itemLabel(options) {
              return {
                ...options,
                className: 'flex w-full',
              };
            },
            list: {
              className: 'w-full',
            },
            ...props.pt,
          }}
          {...props}
          ref={undefined}
          //@ts-expect-error automatically integrates with react-hook-form ref from <Controller ..,. />
          focusInputRef={props.ref}
        />
      );
    }
    return (
      <LabelWrapper
        label={label}
        imp={imp}
        error={error}
        containerClassName={containerClassName}
        containerStyles={containerStyles}
        labelClassname={labelClassname}
        matchTitleOfInfoText={matchTitleOfInfoText}
      >
        <Dropdown
          showOnFocus
          resetFilterOnHide={filter}
          filterInputAutoFocus={filter}
          autoOptionFocus={filter}
          showClear={showClear}
          filter={filter}
          showFilterClear={filter}
          value={value}
          onChange={onChange}
          options={options}
          optionLabel={
            optionLabel?.toLowerCase() === 'none' ? undefined : optionLabel
          }
          placeholder={placeholder || t('dropdownPlaceholder')}
          style={style}
          className={cn('w-full', className)}
          itemTemplate={(option) => {
            return (
              <EllipseLabel
                label={optionLabel === 'none' ? option : option[optionLabel]}
              />
            );
          }}
          pt={{
            itemLabel(options) {
              return {
                ...options,
                className: 'flex w-full',
              };
            },
            list: {
              className: 'w-full',
            },
            ...props.pt,
          }}
          {...props}
          ref={undefined}
          //@ts-expect-error automatically integrates with react-hook-form ref from <Controller ..,. />
          focusInputRef={props.ref}
        />
        {footer}
      </LabelWrapper>
    );
  },
);

Select.displayName = 'Select';
